import { Controller } from 'stimulus'

export default class extends Controller {
  toggleTranslation () {
    this.element.classList.toggle('review--translated')
  }
}
